module.exports = __webpack_public_path__ + "img/rin kaenbyou_sc2.56d42de0.png";